import React from 'react'

export default class Enroll extends React.PureComponent {

    constructor(props) {
        super(props)
        this.state = {
            step1Text: "",
            step1FileTitle: [],
            step1FileName: [],
            step2Text: "",
            step3Number: "",
            description: ""
        }
    }

    componentWillReceiveProps(props) {
        let {product} = props
        let {step1Text, step1FileTitle, step1FileName, step2Text, step3Number, description} = this.state
        let productName = product.name
        this.props.dataApi.fetchEnrollData(function (response) {
                step1Text = response[productName]['step_1_text']
                step1FileTitle = response[productName]['step_1_file_title']
                step1FileName = response[productName]['step_1_file_name']
                step2Text = response[productName]['step_2_text']
                step3Number = response[productName]['step_3_number']
                description = response[productName]['description']
                this.setState({step1Text, step1FileTitle, step1FileName, step2Text, step3Number, description})
            }.bind(this)
        )
    }

    componentDidMount() {
        let {product} = this.props
        let {step1Text, step1FileTitle, step1FileName, step2Text, step3Number, description} = this.state
        let productName = product.name
        this.props.dataApi.fetchEnrollData(function (response) {
                step1Text = response[productName]['step_1_text']
                step1FileTitle = response[productName]['step_1_file_title']
                step1FileName = response[productName]['step_1_file_name']
                step2Text = response[productName]['step_2_text']
                step3Number = response[productName]['step_3_number']
                description = response[productName]['description']
                this.setState({step1Text, step1FileTitle, step1FileName, step2Text, step3Number, description})
            }.bind(this)
        )
    }

    render() {
        const { product, translationData} = this.props
        console.log(product);
        let {step1Text, step1FileTitle, step1FileName, step2Text, step3Number, description} = this.state
        const imgSrc = 'assets/images/company/' + product.logo
        const pdfSrc = 'assets/pdf/'
        return (
            <div className="row">
                <div className="selected-product-logo">
                    <img src={imgSrc} className="img-responsive" alt=""/>
                </div>
                {
                    product.group !== 0 ?
                        <div>
                            <div className="enroll-content row-eq-height">
                                <div className="col-md-4 enroll-step">
                                    <p className="step-title">{translationData.enroll.step} 1</p>
                                    <p className="step-comment">{step1Text}</p>
                                    {
                                        step1FileTitle.map(function (item, index) {
                                            return <a key={index} className="step-link" rel="noopener noreferrer" href={pdfSrc + step1FileName[index]}
                                                      target="_blank">{item}</a>
                                        })
                                    }
                                </div>
                                <div className="col-md-4 enroll-step">
                                    <p className="step-title">{translationData.enroll.step} 2</p>
                                    <p className="step-comment">{step2Text}</p>
                                </div>
                                <div className="col-md-4 enroll-step">
                                    <p className="step-title">{translationData.enroll.step} 3</p>
                                    <p className="step-comment">{translationData.enroll.step_3_text}</p>
                                    <a className="step-tel" href={"tel:+" + step3Number.replace(/-/gi, "")}>{step3Number}</a>
                                </div>
                            </div>
                            <div className="col-md-8 col-md-offset-2">
                                <div className="enroll-description" dangerouslySetInnerHTML={{__html: description}}/>
                            </div>
                        </div>
                        :
                         <div className="col-md-8 col-md-offset-2">
                             <div className="non-enroll-description">
                                <h1 dangerouslySetInnerHTML={{__html: description}} />
                             </div>
                         </div>
                }

            </div>
        )
    }
}